import React, { useEffect } from 'react';

/**
 * props:
 * - indexes
 * - onChange
 * - variant: 'inline' | 'stacked'
 */
function IndexSelect(props) {
    const variant = props.variant || 'inline';
    const indexes = Array.isArray(props.indexes) ? props.indexes : [];
    const placeholder = props.placeholder || (indexes.length === 0 ? 'No indicators available' : '');

    function getOptionText(symbol, variable) {
        return /^(F?WALLET_\d+)$/.test(variable) ? `${symbol}:${variable}` : variable;
    }

    useEffect(() => {
        if (indexes.length > 0 && props.onChange) {
            props.onChange({ target: { id: 'eval', value: indexes[0].eval } });
        }
    }, [indexes.length, indexes[0]?.eval]);

    const selectEl = (
        <select
            id="eval"
            className="form-select"
            onChange={props.onChange}
            disabled={indexes.length === 0}
        >
            {indexes.length > 0 ? (
                indexes.map(item => (
                    <option key={`${item.symbol}:${item.variable}`} value={item.eval}>
                        {getOptionText(item.symbol, item.variable)}
                    </option>
                ))
            ) : (
                <option value="">{placeholder}</option>
            )}
        </select>
    );

    if (variant === 'stacked') {
        return (
            <div className="private-page-field">
                <label htmlFor="eval" className="private-page-label">When</label>
                {selectEl}
            </div>
        );
    }

    return (
        <div className="input-group input-group-merge mb-2">
            <span className="input-group-text bg-secondary">
                When
            </span>
            {selectEl}
        </div>
    )
}

export default IndexSelect;